import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  withRouter,
} from 'react-router-dom';
import {
  ExtendedBox,
  ExtendedFlex,
} from '../coreui';
import withPortal from '../withPortal';

import actions from './actions';

import FooterSection1 from './components/FooterSection1';
import FooterSection2 from './components/FooterSection2';
import FooterSection3 from './components/FooterSection3';

const footerRoot = typeof document !== 'undefined' ? document.getElementById('react-footer') : null;

class Footer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLimitedNav: false,
    };

    this.setNavTypes = this.setNavTypes.bind(this);
  }

  UNSAFE_componentWillMount() {
    this.props.getFooterDataRequested();
    this.setNavTypes(this.props.location.pathname);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.location.pathname !== this.props.location.pathname) {
      this.setNavTypes(nextProps.location.pathname);
    }
  }

  setNavTypes(pathname) {
    const limitedPaths = ['/invest/', '/user/register'];

    const isLimitedNav = limitedPaths.reduce((accum, item) => {
      return pathname.includes(item) ? true : accum;
    }, false);

    this.setState({
      isLimitedNav,
    });
  }

  render() {
    const { items, socialMediaItems } = this.props;
    const { isLimitedNav } = this.state;

    return (
      <ExtendedFlex
        bg="gray.9"
        w={1}
        align="center"
        justify="center"
        px={['10%']}
        py={isLimitedNav ? 0 : '5%'}
      >
        <ExtendedBox w={1} maxWidth={1600}>
          <ExtendedFlex
            flexDirection={['column', 'column', 'row', 'row', 'row']}
            display={isLimitedNav ? 'none' : 'flex'}
            w={1}
            mb={[40, 40, 0]}
          >
            <FooterSection1 items={items} />
            <FooterSection2 items={socialMediaItems} />
          </ExtendedFlex>
          <FooterSection3 isLimitedNav={isLimitedNav} />
        </ExtendedBox>
      </ExtendedFlex>
    );
  }
}

const mapStateToProps = (state) => ({
  items: state.footer.items,
  socialMediaItems: state.footer.socialMediaItems,
});

const mapDispatchToProps = (dispatch) => ({
  getFooterDataRequested: () => {
    dispatch(actions.getFooterDataRequested());
  },
});

Footer.propTypes = {
  getFooterDataRequested: PropTypes.func,
  items: PropTypes.array,
  socialMediaItems: PropTypes.array,
  location: PropTypes.object,
};

export default withPortal(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(Footer)),
  footerRoot,
);
